import {
  PayloadAction,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';

import { LoadingStates } from '@tdp/common/constants';
import { createEntityFormAdapter } from '@tdp/common/form';

import { IAppDetails, IAppDetailsSchema, IAppLobPublish } from './abstractions';
import { EmptyAppDetails } from './constants';

// need to use the full type declaration because 'id' isn't defined on bot
const appDetailsEntityAdapter = createEntityAdapter<IAppDetails, string>({
  selectId: (app) => app.appId,
});
const appDetailsFormAdapter = createEntityFormAdapter(appDetailsEntityAdapter);

const initialState = appDetailsFormAdapter.getInitialState({
  loading: false,
  appDetailsApiStatus: LoadingStates.NOT_STARTED,
});

const entitySelectors = appDetailsEntityAdapter.getSelectors();

export const appDetailsSlice = createSlice({
  name: 'appDetails',
  initialState,
  reducers: {
   appDetailsLoading: (state) => {
      state.appDetailsApiStatus = LoadingStates.LOADING;
    },
    appDetailsLoadingFailed: (state) => {
      state.appDetailsApiStatus = LoadingStates.ERROR;
    },
     appDetailsLoadingSuccess: (state) => {
      state.appDetailsApiStatus = LoadingStates.SUCCESS;
    },
    loadApp(state, action: PayloadAction<IAppDetails>) {
      appDetailsEntityAdapter.upsertOne(state, action.payload);
      state.loading = false;
    },
    ...appDetailsFormAdapter.getReducers(),

  },
  selectors: {
    getAppDetailsApiStatus: (s) => s.appDetailsApiStatus,
    isLoading: (s) => s.loading,
    getAppById: (s, id: string) => entitySelectors.selectById(s, id),
    ...appDetailsFormAdapter.getSelectors(EmptyAppDetails, IAppDetailsSchema),
  },
});


// App publishing.
const appPublishingEntityAdapter = createEntityAdapter<{ id: string, value: IAppLobPublish }, string>({
  selectId: (model) => model.id,
});

const appPublishingSelectors = appPublishingEntityAdapter.getSelectors();

export const appPublishingSlice = createSlice({
  name: 'appPublishing',
  initialState: appPublishingEntityAdapter.getInitialState(),
  reducers: {
    appLobPublishSuccess(state, action: PayloadAction<{ response: IAppLobPublish; id: string }>) {
      appPublishingEntityAdapter.upsertOne(state, { id: action.payload.id, value: action.payload.response });
    },
    appLobRequestDeleteSuccess(state, action: PayloadAction<string>) {
      appPublishingEntityAdapter.removeOne(state, action.payload);
    }
  },
  selectors: {
    getAppPublishingById: (s, id: string) => appPublishingSelectors.selectById(s, id) as { id: string, value: IAppLobPublish } | undefined,
  }
})
